import bus from "@/bus";

const storePublisherPlugin = (store) => {
  store.subscribe((mutation, state) => {
    let obj = {};
    obj.mutation = mutation;
    obj.state = state;
    bus.$emit("mutation", obj);
  });
};

export default storePublisherPlugin;
